<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<!-- suppress UnterminatedStatementJS -->
<template>
  <div class="flex-search">
    <v-container>
      <div class="section">
        <h1 class="batch-search-header">Batch Search Dashboard</h1>
        <h2 class="upload-header">Upload and manage batch search files.</h2>
        <v-btn
          small
          color="primary"
          class="new-search-btn"
          :disabled="checkStartButtonPermission()"
          @click.stop="navigateToFileUpload()"
          ><v-icon class="plus-circle">fa fa-plus-circle</v-icon>Start new
          search</v-btn
        >
        <flex-search-data-table />
      </div>
      <v-snackbar
        top
        :timeout="10000"
        :color="toasterMessage.mode"
        :value="toasterMessage.text"
      >
        <span v-html="toasterMessage.text" />

        <a @click.stop="clearMessage"> Close </a>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import vueDropzone from "vue2-dropzone"
import axios from "axios"

import { API } from "@/common/constants"
import LineItemCard from "@/components/LineItemCard"

import toasterMixin from "@/mixins/toaster"
import FlexSearchDataTable from "@/components/FlexSearch-DataTable"

export default {
  name: "FlexSearch",
  mixins: [toasterMixin],

  data: () => ({
    searchTypes: [],

    columnMappingError: ""
  }),

  methods: {
    navigateToFileUpload() {
      this.$router.push("/flex-search/file-upload")
    },
    checkStartButtonPermission() {
      return this.searchTypes.length === 0
    }
  },
  created() {
    axios.get(API.SEARCHTYPE_ENDPOINT).then(response => {
      this.searchTypes = response.data
    })
  },

  components: {
    FlexSearchDataTable,
    vueDropzone,
    LineItemCard
  }
}
</script>

<style lang="scss" scoped>
.flex-search {
  /deep/ .fa-cloud-upload {
    margin-right: 0.5rem;
  }

  /deep/ .dz-preview {
    .dz-image,
    .dz-details {
      z-index: 7; // any value that is less than 8 which is the z-index for nav menu
    }
  }

  .search-types-table {
    list-style: none;
  }

  .section {
    margin-top: 1rem;
  }

  .batch-search-header {
    color: $color-ec-black1;
    font-size: 1.875rem;
    font-weight: $heavy;
    line-height: 2.25rem;
    text-align: left;
    padding-top: 2.6rem;
  }

  .upload-header {
    color: $color-ec-black1;
    font-size: 1rem;
    font-weight: $normal;
    text-align: left;
    padding-bottom: 1.5rem;
  }

  .new-search-btn {
    background-color: $color-ec-blue;
    border-radius: 0.25rem;
    box-shadow: 0 0.0625rem 0.0625rem 0 rgba(0, 0, 0, 0.11999999731779099),
      0 0.0625rem 0.0625rem 0 rgba(0, 0, 0, 0.23999999463558197);
    width: 13.625rem;
    height: 2.9rem;
    text-decoration-color: $color-white;
    font-size: 1.125rem;
    font-weight: $heavy;
    line-height: 1.375rem;
    margin-left: 0;
  }

  .plus-circle {
    color: $color-white;
    padding-right: 0.75rem;
    font-size: 1.5rem;
    line-height: 1.8rem;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FlexSearch.vue